import { FrequencyType } from '../enums/FrequencyType';
import { PaymentFlow } from '../enums/PaymentFlow';
import { Frequency } from '../interface/fee.interface';
import { toApiDateString } from './date.utils';

export interface FeeFrequencyOption {
  value: Frequency;
  labelKey: string;
}

export const FEE_FREQUENCY_OPTIONS: FeeFrequencyOption[] = [
  { value: FrequencyType.DAILY_SINGLE_PAY, labelKey: 'fee.frequency_types.DAILY_SINGLE_PAY' },
  { value: FrequencyType.DAILY, labelKey: 'fee.frequency_types.DAILY' },
  { value: FrequencyType.WEEKLY, labelKey: 'fee.frequency_types.WEEKLY' },
  { value: FrequencyType.MONTHLY, labelKey: 'fee.frequency_types.MONTHLY' },
  { value: FrequencyType.ANNUAL, labelKey: 'fee.frequency_types.ANNUAL' }
];

export interface PaymentFlowOption {
  value: PaymentFlow;
  labelKey: string;
}

export const FEE_PAYMENT_FLOW_OPTIONS: PaymentFlowOption[] = [
  {value: PaymentFlow.START_OF_CYCLE, labelKey: 'fee.payment_flow_types.START_OF_CYCLE'},
  {value: PaymentFlow.END_OF_CYCLE, labelKey: 'fee.payment_flow_types.END_OF_CYCLE'}
];

export const DEFAULT_PAYMENT_FLOW = PaymentFlow.END_OF_CYCLE;

export function isDailySinglePayFrequency(frequency: unknown): boolean {
  return frequency === FrequencyType.DAILY_SINGLE_PAY;
}

export function resolveSubgroupEndDate(
  frequency: unknown,
  startDate: unknown,
  endDate: unknown
): string | null {
  const raw = isDailySinglePayFrequency(frequency) ? startDate : endDate;
  return toApiDateString(raw);
}

export function frequencyTranslationKey(freq: string | undefined): string {
  return `fee.frequency_types.${(freq || '').toUpperCase()}`;
}
